import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TableRow, TableCell, Tag, Button } from 'carbon-components-react';
import UtilityIcon from 'components/UtilityIcons';
import { setEditMemberModelOpenStart, setEditMemberInit } from 'redux/member';

const DisplayMemberRow: React.FC<any> = ({ row, getRowProps }: any) => {
  const dispatch: any = useDispatch();

  const onClickEdit = () => {
    dispatch(
      setEditMemberInit({
        type: 'EDIT',
        data: {
          id: row.id,
          name: row.cells[0].value,
          utilityId: row.cells[1].value,
          organizationType: row.cells[2].value,
          tenant: row.cells[4].value
        }
      })
    );
    dispatch(setEditMemberModelOpenStart(true));
  };

  const [selected, setSelected] = useState<boolean>(false);

  const handleOnMouseEnter = () => setSelected(true);
  const handleOnMouseLeave = () => setSelected(false);

  return (
    <>
      <TableRow
        {...getRowProps({ row })}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
      >
        <TableCell
          className={row.cells[3].value ? 'disabled-row' : ''}
          key={'organisationType'}
        >
          <UtilityIcon type={row.cells[2].value} />
        </TableCell>
        <TableCell
          className={row.cells[3].value ? 'disabled-row' : ''}
          key={'name'}
        >
          {row.cells[0].value}
        </TableCell>
        <TableCell
          className={row.cells[3].value ? 'disabled-row' : ''}
          key={'utilityId'}
        >
          {row.cells[1].value}
        </TableCell>
        <TableCell
          className={row.cells[3].value ? 'disabled-row' : ''}
          key={'territory'}
        >
          {row.cells[4].value}
        </TableCell>
        <TableCell key={'isDisabled'}>
          {row.cells[3].value && <Tag type="blue">Disabled</Tag>}
        </TableCell>
        <TableCell className="bx--table-column-menu">
          {selected && (
            <Button kind="ghost" className="row-edit-btn" onClick={onClickEdit}>
              Edit
            </Button>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
DisplayMemberRow.displayName = 'DisplayMemberRow';
export default DisplayMemberRow;
